import gameData from "../../gameData.js";
import Game from "./Game.js";

export default class Game_Snake
{
    /**
     * @param {Game} scene 
     */
    constructor(scene, x, y, units, collideGroup, noCollideGroup, collideCat, noCollideCat, contOveride = null)
    {
        this.scene = scene;
        this.units = units;
        this.noCollideCat = noCollideCat;
        this.noCollideGroup = noCollideGroup;

        if(contOveride !== null) {
          const bounds = contOveride.getBounds();
          contOveride.setSize(bounds.width, bounds.height);

          this.image = this.scene.matter.add.gameObject(contOveride, {
            shape: 'rectangle',
            friction: 0.005,
            restitution: 0.6,
            collisionFilter: { group: collideGroup },
            density: .1
          }, true);

          this.image.x = x;
          this.image.y = y;
        }
        else {
          this.image = this.scene.matter.add.image(x, y, this.scene.defaultAtlas, (gameData.curSnakeIndex + 1) + "_game" + this.units, {
            friction: 0.005, 
            restitution: 0.6,
            density: .1,
            collisionFilter: { group: collideGroup },
          });
        }

        this.image.setBody({
          type: 'rectangle', 
          width: this.units == 100 ? 200 : this.units == 1 ? 27 : 22, 
          height: this.units == 1 ? 27 : 200
        });

        this.image.body.snake = this;
        this.image.setFrictionAir(.05);
        this.image.setCollisionCategory(collideCat);
        this.image.setCollidesWith([collideCat]);
        if(contOveride === null){
          this.image.setInteractive({ pixelPerfect: true });
        }
        else{
          this.image.setInteractive();
        }
        this.image.setBounce(1);

        this.image.on("pointerdown", ()=>{
            this.setSelected();
        });

        this.hasBeenPlaced = false;

        this.scene.input.on("pointerup", ()=>{
            if(!this.isSelected || !this.image) return;

            if(!this.inBounds && gameData.curGameType != "COUNT" && this.hasBeenPlaced)
            {
                this.scene.removeSnake(this);
                this.destroy();
            }
            else
            {
                if(!this.hasBeenPlaced)
                {
                    this.image.disableInteractive();
                    this.scene.addDelay(300, ()=>{
                        this.image.setInteractive();
                    });
                }
                this.hasBeenPlaced = true;
                this.image.setDepth(1);

                this.image.setCollisionCategory(collideCat);
                this.image.setCollisionGroup(collideGroup);

                this.scaleTo(1, 500);
                this.isSelected = false;
                this.scene.playSound("put_down");
            }
        });

        this.emitter = this.scene.add.particles(this.scene.defaultAtlas, 'SnakeParticle').createEmitter({
            tint: gameData.snakeTypes[gameData.curSnakeIndex].colors,
            scale: { start: .5, end: 0 },
            speed: {min: -100, max: 100 }
        });

        this.emitter.stop();
    }

    animateIn()
    {
        this.scene.playSound("pick_up");
        
        this.image.scale = 0.4;
        this.image.alpha = 0;

        this.scaleTo(1, 500);
        this.scene.addTween(this.image, 800, {alpha: 1}, Phaser.Math.Easing.Back.Out);
    }

    setSelected(scale = true)
    {
        this.scene.playSound("pick_up");

        this.isSelected = true;
        this.inBounds = true;
        this.image.setDepth(2);

        this.image.setCollisionCategory(this.noCollideCat);
        this.image.setCollisionGroup(this.noCollideGroup);

        if(scale) this.scaleTo(1.1, 500);
        this.stopBody();
    }

    updateSnakeImage()
    {
        this.scaleTo(0.1, 200, ()=>{
            this.scene.killTween(this.image);
            
            this.image.scale = 2;
            this.image.alpha = 0;
            this.scaleTo(1, 500);

            this.image.setFrame((gameData.curSnakeIndex + 1) + "_game" + this.units, false, false);
            this.scene.addTween(this.image, 1000, { alpha: 1 });
        },Phaser.Math.Easing.Sine.Out);
    }

    scaleTo(scale, duration, onComplete, ease = "Back")
    {
        this.scene.killTween(this.image);
        this.image.scale = this.image.scaleX;
        this.scene.addTween(this.image, duration, { scale: scale }, ease, onComplete);
    }

    destroy()
    {
        this.emitZone = {
            source: new Phaser.Geom.Rectangle(0, 0, this.image.displayWidth, this.image.displayHeight),
            type: 'random',
        };
        this.emitter.setEmitZone(this.emitZone);
        this.emitter.setQuantity(this.units == 1 ? 10 : this.units == 10 ? 100 : this.units == 100 ? 1000 : 0);
        this.emitter.setQuantity(200);
        this.emitter.tint.propertyValue = gameData.snakeTypes[gameData.curSnakeIndex].colors;
        this.emitter.manager.x = this.image.x - this.image.displayWidth * .5;
        this.emitter.manager.y = this.image.y - this.image.displayHeight * .5;
        this.emitter.explode();
        this.scene.playSound("snake_evaporate");

        this.image.destroy();
        this.image = null;
    }

    update()
    {
        if(!this.image) return;
        this.image.angle = 0;
        if(this.isSelected)
        {
            if(gameData.curGameType != "COUNT" && this.hasBeenPlaced)
            {
                if(this.inBounds && !this.checkBounds) //We're out of bounds
                {
                    this.inBounds = false;
                    this.scaleTo(.8, 200);
                    this.image.tint = 0xffaaaaaa;
                }
                else if(!this.inBounds && this.checkBounds) //We're in bounds
                {
                    this.inBounds = true;
                    this.scaleTo(1.1, 200);
                    this.image.tint = 0xffffff;
                }
            }
            return;
        }

        let bnds = this.scene.activeRegion;
        let img_bnds = this.image.body.bounds;
        let halfWidth = (img_bnds.max.x - img_bnds.min.x) * .5;
        let halfHeight = (img_bnds.max.y - img_bnds.min.y) * .5;

        this.minX = bnds.left + halfWidth;
        this.maxX = bnds.right - halfWidth;
        this.minY = bnds.top + halfHeight;
        this.maxY = bnds.bot - halfHeight;
        
        let force = .001 + this.units/500; //1 + this.units/3;
        if(this.image.x < this.minX)
        {
            this.image.applyForce({x: force, y: 0});
        }
        if(this.image.x > this.maxX)
        {
            this.image.applyForce({x: -force, y: 0});
        }
        if(this.image.y < this.minY)
        {
            this.image.applyForce({x: 0, y: force});
        }
        if(this.image.y > this.maxY)
        {
            this.image.applyForce({x: 0, y: -force});
        }
    }

    get checkBounds()
    {
        this.minX = this.scene.activeRegion.left;
        this.maxX = this.scene.activeRegion.right;
        this.minY = this.scene.activeRegion.top;
        this.maxY = this.scene.activeRegion.bot;
        if (this.image.x < this.minX || this.image.x > this.maxX || this.image.y < this.minY || this.image.y > this.maxY) {
            return false;
        }
        return true;
    }

    stopBody()
    {
        this.image.body.positionPrev = {x: this.image.x, y: this.image.y};
    }
}